import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CoreHttpClient } from "../../http-client/http-client.service";
import { OPEN_ID_CONNECT_CURRENT_JOURNEY_KEY } from "../google/google-auth-transaction.const";

import { DgaAuthTransactionConfigService } from "./dga-auth-transaction.config";
import {
	ExperianData,
	ExperianDataRequest,
	NemIdAuthInitializeSuccessPayload,
	NemIdAuthTransactionRequest,
	NemIdAuthTransactionResponse,
	NemIdVerificationStatusResponse,
	OpenIdConnectResponse,
	OpenIdConnectUrlRequest,
} from "./dga-auth-transaction.model";

@Injectable({
	providedIn: "root",
})
export class DgaAuthTransactionService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: DgaAuthTransactionConfigService
	) {}

	getExperianData(request: ExperianDataRequest): Observable<ExperianData> {
		return this.httpClient.get<ExperianData>({
			url: this.config.getExperianDataEndpoint(),
			searchParams: request,
		});
	}

	initializeAuthTransaction(request: NemIdAuthTransactionRequest): Observable<NemIdAuthTransactionResponse> {
		return this.httpClient.post<NemIdAuthTransactionResponse>({
			url: this.config.getVerificationEndpoint(),
			data: request,
		});
	}

	getStatus(request: NemIdAuthInitializeSuccessPayload): Observable<NemIdVerificationStatusResponse> {
		return this.httpClient.get<NemIdVerificationStatusResponse>({
			url: this.config.getVerificationStatusEndpoint(),
			searchParams: request,
		});
	}

	getOpenIdConnectUrl(request: OpenIdConnectUrlRequest): Observable<OpenIdConnectResponse> {
		return this.httpClient.get<OpenIdConnectResponse>({
			url: this.config.getOpenIdConnectUrlEndpoint(),
			searchParams: request,
		});
	}

	setCurrentJourney(provider: string): void {
		sessionStorage.setItem(OPEN_ID_CONNECT_CURRENT_JOURNEY_KEY, provider);
	}
}
